import CryptoJS from 'crypto-js'

function base64url(source) {
  // Encode in classical base64
  let encodedSource = CryptoJS.enc.Base64.stringify(source)

  // Remove padding equal characters
  encodedSource = encodedSource.replace(/=+$/, '')

  // Replace characters according to base64url specifications
  encodedSource = encodedSource.replace(/\+/g, '-')
  encodedSource = encodedSource.replace(/\//g, '_')

  return encodedSource
}

const JWTUtils = {
  async createToken(data) {
    const header = {
      alg: 'HS256',
      typ: 'JWT',
    }

    // encode header
    var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header))
    var encodedHeader = base64url(stringifiedHeader)

    // encode data
    var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data))
    var encodedData = base64url(stringifiedData)

    // build token
    var token = `${encodedHeader}.${encodedData}`

    // sign token
    var signature = CryptoJS.HmacSHA256(token, process.env.REACT_APP_JWT_API_KEY)
    signature = base64url(signature)
    var signedToken = `${token}.${signature}`

    return signedToken
  },
}

export default JWTUtils
